export default __webpack_public_path__ + "static/media/warehouseAlt2.b7ba0105.svg";